import { useMemo } from 'react';
import { SideBarDef } from 'ag-grid-community';

export const useSideBarConfiguration = () => {
  const sideBarConfiguration = useMemo<SideBarDef>(
    () => ({
      hiddenByDefault: false,
      toolPanels: [
        {
          iconKey: 'columns',
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          toolPanelParams: {
            suppressPivotMode: true,
            suppressRowGroups: true,
            suppressValues: true,
          },
        },
      ],
    }),
    []
  );

  return { sideBarConfiguration };
};
